<template>
  <div class="containter">
    <navTop class="navTop navFixed" :topFixed="true" :topIndex="topIndex" :childrenIndex="childrenIndex" />
    <banner :bannerObj="bannerObj" @dialogVisible="getChild" />
    <p class="equipment-title">解决方案</p>
    <product-content
      :productContentArr = product
    />
    <footer-a />
    <back-top />
    <dialog-business :dialogVisible="dialogVisible" @dialogVisible="closeFn"/>
  </div>
</template>

<script>
import navTop from '../components/nav'
import banner from '../components/banner'
import productContent from '../components/productContent'
import footerA from '../components/footer'
import backTop from '../components/backTop'
import dialogBusiness from '../components/dialogBusiness'
import i1 from '../assets/images/equipment/1.png'
import i2 from '../assets/images/equipment/2.png'
import i3 from '../assets/images/equipment/3.png'
import i4 from '../assets/images/equipment/4.png'
export default {
  data () {
    return {
      product: [
        {img: i1, boxStyle: '', content: '实时在线监控所有终端设备运营，状态监控，精准定位', label: '资产分布图', type: 'left', style: 'width: 1.77rem;padding-left: 0.48rem;'},
        {img: i2, boxStyle: '', content: '可打通生产、仓库系统，从合同管理、发货跟踪、目的地监控、营收表现，异常处理到资产流转，合作状态变更，资产全生命周期管理', label: '资产全生命周期管理', type: 'right', style: 'width: 1.77rem;padding-right:0.68rem;'},
        {img: i3, boxStyle: '', content: '多级代理、灵活分润、明细核对；客户端、代理端，各角色权限管控；可视化报表，多维度交叉统计分析', label: '智能分润', type: 'left', style: 'width: 1.77rem;padding-left: 0.48rem;'}
      ],
      bannerObj: {
        img: i4,
        title: '设备运营商解决方案',
        contentStyle: 'font-size: 0.00625rem;line-height: 0.11rem;',
        content: '以游乐游艺设备运营为例，目前大致可分为场地提供方、设备制造商和资金提供方，而部分设备运营商会兼具多种属性，现有市场产品无法全面满足各方需求，且存在资产管理、数据同步、分润不明晰等问题，前海智绘针对这一场景，专门研发出智能分润系统，包含设备远程监控、资产运营管理及智能分润模块，全面满足设备运营商的复合需求。',
        button: '业务咨询'
      },
      topIndex: 2,
      childrenIndex: 1,
      dialogVisible: false
    }
  },
  components: {
    navTop,
    banner,
    productContent,
    backTop,
    dialogBusiness,
    footerA
  },
  methods: {
    getChild (v) {
      this.dialogVisible = v
    },
    closeFn (v) {
      this.dialogVisible = v
    }
  }
}
</script>

<style scoped>
.equipment-title{
  font-size:34px;
  font-family:PingFang SC;
  font-weight:bold;
  color:rgba(51,51,51,1);
  padding: 110px 0 30px;
  margin-bottom: 68px;
}
</style>



// WEBPACK FOOTER //
// src/view/equipment.vue